module.exports = "https://99designs-start-assets.imgix.net/js/0517d5d4ff4474e71e9819ca765d02fe.svg";